import { Navigate } from 'react-router-dom';

/**
 * Editing by confirmation code is retired. A confirmation code is not a secret
 * (it is printed on the confirmation page and readable through the public
 * applications listing), so it cannot authorize an edit. Families now request a
 * one-time edit link that is emailed to the address on the application.
 * Old bookmarks and emailed links to /edit/<code> land on that request page.
 *
 * Deliberately not lazy-loaded: a redirect should never need its own chunk.
 */
export const EDIT_LINK_REQUEST_PATH = '/edit-link/request';

const LegacyEditRedirect = () => <Navigate replace to={EDIT_LINK_REQUEST_PATH} />;

export default LegacyEditRedirect;
